module.exports = __webpack_public_path__ + "img/period.2928c746.png";